import core, { App } from '@gin-betting/core';

const { isOneOfPages } = core.utils;

export default function isLivePage(): boolean {
    return isOneOfPages([App.Routes.LIVE_LIST], { exact: false });
}
